import { Component, OnInit } from '@angular/core';
import { PositionEnteredNotificationComponent } from '../position-entered-notification/position-entered-notification.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ToastrService, ToastPackage } from 'ngx-toastr';
import { ShareService } from '../../services/share.service';
import { WorkspaceServiceService } from '../../services/workspace-service.service';

@Component({
  selector: '[mobile-position-entered-notification]',
  template: require('./mobile-position-entered-notification.component.html'),
  styles: [require('./mobile-position-entered-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])],
})
export class MobilePositionEnteredNotificationComponent extends PositionEnteredNotificationComponent 
{
  footerHeight: string | undefined;
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, public shareService: ShareService, public workspaceService: WorkspaceServiceService) 
  {
    super(toastrService, toastPackage, shareService, workspaceService);
  }
}
